import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { SpinnerDialog } from '@ionic-native/spinner-dialog';

@Component({
    selector: 'back-button',
    templateUrl: 'back-button.html'
})
export class BackButtonComponent {

    constructor(
        private navCtrl: NavController,
        private spinner: SpinnerDialog,
    ) {
    }

    async goBack() {
        this.spinner.show();
        if (this.navCtrl.canGoBack())
            this.navCtrl.pop();
        this.spinner.hide();
    }

}



// WEBPACK FOOTER //
// ./src/components/back-button/back-button.ts